import { useActivityBuilderFlags } from 'approot/activity-builder/activity-builder-flags';
import { useTeacherGetAnswers } from 'approot/activity-builder/present/activity-answers.hooks';
import { useActivityBuilderPresentContext } from 'approot/activity-builder/present/activity-builder-present.context';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import SubActivityView from '../sub-activity/sub-activity-view';
import TableCheckAnswer from './table-check-answer';
import TableReadonlyAnswers from './table-readonly-answers';
import { ViewProps } from './table.constants';
import ComponentOverlay from '../shared/component-overlay/component-overlay';
import { ComponentOverlayWrapper } from '../shared/component-overlay/component-overlay.style';
import { getTableStudentAnswerCount } from 'approot/activity-builder/classroom/table/table-response-individual.utils';
import { getComponentSelectorId } from '../shared/logic/get-component-selector-id';
import { getSubActivityInstructionAsText } from '../sub-activity/sub-activity.utils';

const TableView = (props: ViewProps) => {
  const {
    id,
    subActivityProperties,
    properties: {
      table: { isReadOnly },
    },
  } = props;
  const { isVisible, openModal, closeModal } = useSimpleModalState();
  const { activityBuilderRespondFlag } = useActivityBuilderFlags();
  const { isPublished } = useActivityBuilderPresentContext();

  const { componentAnswers, hasFetchedAnswers, error } = useTeacherGetAnswers({
    componentId: id,
    skip: !activityBuilderRespondFlag,
  });

  return (
    <SubActivityView subActivityDetails={subActivityProperties}>
      {isVisible && (
        <TableCheckAnswer {...props} isPublished onClose={closeModal} />
      )}
      <ComponentOverlayWrapper id={getComponentSelectorId(id)}>
        <TableReadonlyAnswers {...props} answers={componentAnswers || null} />
        {isPublished && activityBuilderRespondFlag ? (
          <ComponentOverlay
            ariaLabel={`${
              isReadOnly ? '' : 'Fill in the table to answer: '
            }${getSubActivityInstructionAsText(
              subActivityProperties?.instructions
            )}`}
            componentId={id}
            hasFetchedAnswers={hasFetchedAnswers}
            error={error}
            borderRadius={false}
            onClick={openModal}
            getActiveStudentAnswerCount={answers =>
              isReadOnly ? 0 : getTableStudentAnswerCount(answers)
            }
          />
        ) : null}
      </ComponentOverlayWrapper>
    </SubActivityView>
  );
};

export default TableView;
